import _ from 'lodash';
import LobJob from './LobJob';

function MultiLobs(data) {
    if (data) {
        this.jobs = _.map(data.jobs, (aJob) => {
            return new LobJob(aJob);
        });

        _.extend(this, data);
    } else {
        this.jobs = [];

        this.accountNumber = '';
    }
}

function sortJobs(jobs) {
    return _.sortBy(jobs, (aJob) => {
        return aJob.priority();
    });
}

MultiLobs.prototype.createJob = function (data) {
    return new LobJob(data);
};

MultiLobs.prototype.addJob = function (aJob) {
    this.jobs.push(aJob);
};

MultiLobs.prototype.findJobByID = function (id) {
    return this.jobs.find((job) => job.id === id);
};

MultiLobs.prototype.removeJobByID = function (id) {
    const aJob = this.findJobByID(id);
    const idx = this.jobs.indexOf(aJob);
    if (idx > -1) {
        this.jobs.splice(idx, 1);
    }
};

MultiLobs.prototype.removeOtherJobs = function (id) {
    const aJob = this.findJobByID(id);
    this.jobs = [aJob];
};

MultiLobs.prototype.getJobByJobNumber = function (jobNumber) {
    return this.jobs.find((job) => job.jobNumber === jobNumber);
};

MultiLobs.prototype.hasJobWithID = function (id) {
    return this.findJobByID(id);
};

MultiLobs.prototype.retrieveAllJobs = function () {
    return this.jobs;
};

MultiLobs.prototype.retrieveSingleJob = function () {
    if (this.hasSingleJob()) {
        return this.jobs[0];
    }
    return undefined;
};

MultiLobs.prototype.hasNext = function () {
    if (this.nextJob()) {
        return true;
    }
    return false;
};

MultiLobs.prototype.hasMultiJobs = function () {
    return this.jobs.length > 1;
};

MultiLobs.prototype.hasSingleJob = function () {
    return this.jobs.length === 1;
};

MultiLobs.prototype.nextJob = function () {
    let uncompletedJobs;

    uncompletedJobs = _.filter(this.jobs, (aJob) => {
        return aJob.isBeforeQuoteCompleted !== true;
    });

    if (uncompletedJobs.length === 0) {
        uncompletedJobs = _.filter(this.jobs, (aJob) => {
            return aJob.isAfterQuoteCompleted !== true;
        });

        if (uncompletedJobs.length > 0) {
            return sortJobs(uncompletedJobs)[0];
        }
    }

    if (uncompletedJobs.length === 0) {
        uncompletedJobs = _.filter(this.jobs, (aJob) => {
            return aJob.isPaymentDetailsCompleted !== true;
        });

        if (uncompletedJobs.length > 0) {
            return sortJobs(uncompletedJobs)[0];
        }
    }

    if (uncompletedJobs.length === 0) {
        uncompletedJobs = _.filter(this.jobs, (aJob) => {
            return aJob.isESignatureCompleted !== true;
        });

        if (uncompletedJobs.length > 0) {
            return sortJobs(uncompletedJobs)[0];
        }
    }

    return sortJobs(uncompletedJobs)[0];
};

MultiLobs.prototype.isDuplicated = function (aJob) {
    const anExistingJob = _.findWhere(this.jobs, {
        productCode: aJob.productCode,
        coveragePartType: aJob.coveragePartType,
        postalCode: aJob.postalCode,
        periodStart: aJob.periodStart
    });

    return !!anExistingJob;
};

MultiLobs.prototype.retrieveAllJobs = function () {
    return this.jobs;
};

MultiLobs.prototype.getSortedJobs = function () {
    return sortJobs(this.jobs);
};

MultiLobs.prototype.tagAndSortJobs = function () {
    const sortedJobs = sortJobs(this.jobs);
    const paCount = 0;
    const hoprental = 0;
    const hopdwelling = 0;
    const hopcondo = 0;
    const hopLandlordCondo = 0;
    const hopLandlordHome = 0;
    const pupCount = 0;
    const taggedJobs = _.map(sortedJobs, (aJob) => {
        if (aJob.productCode === 'PersonalAuto') {
            aJob.quoteTag = paCount + 1;
        } else if (aJob.productCode === 'PersonalUmbrella') {
            aJob.quoteTag = pupCount + 1;
        } else if (aJob.productCode === 'HOPHomeowners') {
            if (aJob.coveragePartType === 'hopdwelling') {
                aJob.quoteTag = hopdwelling + 1;
            } else if (aJob.coveragePartType === 'hoprental') {
                aJob.quoteTag = hoprental + 1;
            } else if (aJob.coveragePartType === 'hopcondo') {
                aJob.quoteTag = hopcondo + 1;
            } else if (aJob.coveragePartType === 'hop_landlord_condo_ml') {
                aJob.quoteTag = hopLandlordCondo + 1;
            } else if (aJob.coveragePartType === 'hop_landlord_home_ml') {
                aJob.quoteTag = hopLandlordHome + 1;
            } else {
                console.error(new Error(`Unsupported coverage part type: ${aJob.coveragePartType}`));
            }
        } else {
            console.error(new Error(`Unsupported product code: ${aJob.productCode}`));
        }
        return aJob;
    });

    return taggedJobs;
};

export default MultiLobs;
